import { render, staticRenderFns } from "./inputCopyValue.vue?vue&type=template&id=2149572e"
import script from "./inputCopyValue.vue?vue&type=script&lang=js"
export * from "./inputCopyValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports